module.exports = __webpack_public_path__ + "staticcomp/img/cover.005f31a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/4/cover.jpg
// module id = rAKY
// module chunks = 39